import {
    STOREFRONT_VALUES_KEYS,
    STOREFRONT_VALUES_NAMESPACES,
} from "@/constants/storefront_values";
import { filterNilValue } from "@datorama/akita";
import { StorefrontValuesModule } from "@modules/storefront_values/StorefrontValuesModule";
import { map } from "rxjs";
import { singleton } from "tsyringe";

import WishlistsStorefrontValuesBrandingSchema from "../schemas/WishlistsStorefrontValuesBrandingSchema";
import { WishlistsStorefrontValuesSettingsSchema } from "../schemas/WishlistsStorefrontValuesSettingsSchema";

@singleton()
class WishlistsStorefrontValuesService {
    constructor(
        private readonly storefrontValuesModule: StorefrontValuesModule
    ) {}

    public selectWishlistsSettings() {
        return this.storefrontValuesModule.exports.storefrontValuesManager.selectValue(
            {
                namespace: STOREFRONT_VALUES_NAMESPACES.WISHLIST_CRITICAL,
                key: STOREFRONT_VALUES_KEYS.WISHLIST_SETTINGS,
                schema: WishlistsStorefrontValuesSettingsSchema,
            }
        );
    }

    public selectWishlistsBranding() {
        return this.storefrontValuesModule.exports.storefrontValuesManager.selectValue(
            {
                namespace: STOREFRONT_VALUES_NAMESPACES.WISHLIST_CRITICAL,
                key: STOREFRONT_VALUES_KEYS.WISHLIST_BRANDING,
                schema: WishlistsStorefrontValuesBrandingSchema,
            }
        );
    }

    public selectEnabledSocialShareChannels() {
        return this.selectWishlistsSettings().pipe(
            filterNilValue(),
            map((settings) => {
                return settings?.wishlistSocialShareChannels.filter(
                    (channel) => channel.isEnabled
                );
            })
        );
    }
}

export default WishlistsStorefrontValuesService;
